import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from "react-redux"
import { accionTargetAction } from "../../../../ducks/cambiosDuck"
import useCatalogos from "../../../../hooks/useCatalogos"
import { useSelector } from "react-redux"
export const SAccionStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
}))

const BAccion = () => {
    const { isCancelacion, accion } = useSelector(store => store.cambios)
    const catalogo = useCatalogos("ChangeCancel")
    const Clasess = SAccionStyle()
    const dispatch = useDispatch()
    const handleSelecAccion = (event) => {
        dispatch(accionTargetAction({ accion: event.target.value }))
    }
    return (
        <FormControl variant="outlined" className={Clasess.root}>
            <InputLabel id="lTipoAccion">Acción</InputLabel>
            <Select
                labelId="lTipoAccion"
                id="SlTipoAccion"
                name="tipoUsuario"
                value={accion}
                onChange={handleSelecAccion}
                label="Acción"
            >
                <MenuItem value={0}>
                    {"Seleccione una opción"}
                </MenuItem>
                {catalogo.filter(action => action.Descripcion.includes((isCancelacion) ? "Cancelar" : "Cambiar") ).map((item, index) => (
                    <MenuItem key={item.IdCatCambioCancelacion} value={item.IdCatCambioCancelacion}>
                        {item.Descripcion}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
export default BAccion